export const getGoalDataForTab = (goal, user, formState, studentGoalsData) => {
  const studentId = user?.studentId || user?.id || formState?.studentId;
  const student = studentGoalsData.find((s) => s.id === studentId);
  const fullGoalData = student?.dataCollection?.find(
    (collection) => (collection?.id || collection?.docId) === goal.id
  );

  const goalData = fullGoalData?.goalData || [];
  const validGoalData = Array.isArray(goalData) ? goalData : [];

  // Filter student data points for this specific goal
  const studentDataPoints = validGoalData.filter(
    (dataPoint) => dataPoint.studentId === (user?.studentId || user?.id)
  );

  const criteriaValue =
    fullGoalData?.info?.DataCollection?.measurementType?.Criteria || null;

  const promptingValue =
    fullGoalData?.info?.DataCollection?.PromptingApplicable?.PromptingType ||
    null;

  const multipleDataPointsValue =
    fullGoalData?.info?.DataCollection?.MultipleDataPointsPerSession
      ?.MultipleDataPointsPerSession || 'No';

  // Calculate subGoalIndex by finding the current subgoal
  let subGoalIndex = null;
  const hasSubgoal =
    fullGoalData?.info?.HasSubgoal?.HasSubgoal === 'Yes';

  if (hasSubgoal) {
    let indexCount = 1;
    const subgoals = fullGoalData?.info?.HasSubgoal?.Subgoals || [];
    for (const item of subgoals) {
      if (item?.CurrentGoal === 'Yes') {
        subGoalIndex = indexCount;
        break;
      }
      indexCount++;
    }
  }

  // Get target - use subgoal target if applicable, otherwise main target
  let targetValue = 'N/A';
  if (hasSubgoal && subGoalIndex) {
    const currentSubgoal =
      fullGoalData?.info?.HasSubgoal?.Subgoals?.[subGoalIndex - 1];
    targetValue = currentSubgoal?.Target || 'N/A';
  } else {
    targetValue = fullGoalData?.info?.GoalDetails?.Target || 'N/A';
  }

  return {
    fullGoalData,
    validGoalData,
    studentDataPoints,
    criteriaValue,
    promptingValue,
    multipleDataPointsValue,
    subGoalIndex,
    targetValue,
  };
};

